<template>
  <div id="app">
     <router-view v-if="isRouterAlive"></router-view>
    <span id="audio_ctrl" class="btn-music"></span>
    <div id="res_iframe_box" class="res-iframe">
      <iframe src="" name="resIframe" id="res_iframe"></iframe>
    </div>
    <!--- zmf --->
    <v-audio ref="root_staudio"></v-audio>
    <v-video ref="root_stvideo"></v-video>
    <!-- <v-html-panel :url.asyc="url1"></v-html-panel> -->
  </div>
</template>

<script>
import * as rem from '../static/js/rem-px.js'
import { openAssetsShow,openUrllink } from '@pageRouter/pageRouter'
import { inspectResDulTime } from '@service/getData'
import { mapMutations } from 'vuex'
import * as util from '@static/js/util.js'

export default {
  name: 'App',
  components: {
    'v-audio': function (resolve) {
      require(['@include/newAudio'], resolve)
    },
    'v-video': function (resolve) {
      require(['@include/video'], resolve)
    }
  },
   data(){
	   return{
		   timer: '',
		   previewId:-1,
		   intervalTimes : 0,
		   isRouterAlive:true
		   //previewURL: ''
	   }
   },
   provide(){
  	 return {reload : this.reload};
   },
  computed: {
    unReadNum () {
      return this.$store.getters.getUnReadNum;
    },
  },
  watch: {
    unReadNum (val) {
      console.log("un read count -> " + val)
      this.$bus.$emit("readMsg", val);
    },
    $route (to, from) {
	  console.log("route to:" + to.path + " from:" + from.path);

      //增加去除iframe后
	  if((from.path == '/pdfView' && to.query.preview ) || from.path == '/previewUrl'){
		  this.sendOpenDulTime(to);
	  }
      else if (to.path == from.path) {
        if (from.query.preview && !to.query.preview) {
			this.sendOpenDulTime(from)
			this.$nextTick(window.history.back())
        }
        if (from.query.playvideo && !to.query.playvideo) {
          // $('#res_iframe').hide().attr('src' ,'');
          this.$bus.$emit("closeVideo");
        }
      }else if((to.path != '/pdfView' && to.path != '/previewUrl') && this.timer){
		  //是否增加清除功能,避免用户主动刷新后，无法停止问题
		  clearInterval(this.timer);
	  }
    }
  },
  methods: {
  	reload(){
  	  this.isRouterAlive = false;
  	  this.$nextTick(()=>{
  	  	this.isRouterAlive = true
	  })
	},
  	sendOpenDulTime(from){
		//this.previewURL = '';
		$('#res_iframe').attr('src', '');
		$('#res_iframe_box').hide()
		this.$bus.$emit("closePreview");
		this.$bus.$emit('stopPreview', {
			id: Number(from.query.preview),
			isStop: true
		})

	},

    // preview resource
    previewRes (data,link = false) {
      this.savePreviewData(data)
	  //定时发送
		if(this.timer){
			clearInterval(this.timer);
		}

	  this.previewId = data.id;
      this.timer = setInterval(this.setIntervarDulTime, 5000);

      if(link){
		openUrllink(this,data, true);
      	return;
	  }
      openAssetsShow(this, this.$root.$children[0].$refs.root_staudio, data.previewAddress, data.name, data.name, data.id, data.classId)
    },

	setIntervarDulTime(){
		this.intervalTimes +=1;
		this.$bus.$emit('stopPreview', {
			id: Number(this.previewId),
			isStop: false,
			intervalTime:5
		})
	},

    stopPreview (data) {
      let info = this.$store.state.statisticsMap.get(data.id)
      var endTime = new Date().getTime()
	  var readTime = 0;
	  if(data.intervalTime && data.intervalTime > 0){
		  readTime = 5;
	  }else {
	  	  //避免删除后，在其计算
	  	  if(!info){
	  	  	if(this.timer){
				clearInterval(this.timer);
			}
			this.intervalTimes = 0;
	  	  	return;
		  }
		  readTime = Math.floor((endTime - info.startTime) / 1000)
		  readTime = readTime - this.intervalTimes*5;
		  if(readTime < 0){
		  	 readTime = 0;
		  }
	  }
      if (data.isStop) {
      	if(this.timer){
			clearInterval(this.timer);
		}

		this.intervalTimes = 0;
        this.deletePreviewData(data.id)
      }

      if (util.getFileType(info.name) === 'pic' && readTime <= 1) { // 图片预览时长小于1秒，不统计
        console.log('read-time -> ' + readTime)
        return
      }

      inspectResDulTime(this, info.id, info.classId, readTime).then(function (response) {
        if (!response.data.success) {
          console.log(response.data.message)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    ...mapMutations({
      savePreviewData: 'setStatistics',
      deletePreviewData: 'deleteStatistics'
    })

  },
  beforeDestroy() {
	  clearInterval(this.timer);
  },
  mounted: function () {
    let that = this;

    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {

    } else {
      var height = document.body.clientHeight;
      var width = document.body.clientWidth;
      document.addEventListener('resize', function () {
        $('#app').addClass('pc');
        $('html').css('font-size', '50px').css('height', '100vh').css('overflow', 'auto');
        $('body').css('background-color', '#fff').css('height', '100%').css('width', '414px').css('margin', 'auto').css('height', '736px');
      }, false);
      $('#app').addClass('pc');
      $('html').css('font-size', '55px').css('height', '100vh').css('overflow', 'auto');
      $('body').css('background-color', '#fff').css('height', '100%').css('width', '414px').css('margin', 'auto');
    }
    this.$bus.$off('startPreview').$on('startPreview', (data) => {
      console.log('startPreview --- ' + data)
      this.previewRes(data)
    })
    this.$bus.$off('stopPreview').$on('stopPreview', (data) => {
      console.log('stopPreview --- ' + data)
      this.stopPreview(data)
    })

	//zmf增加链接预览
	this.$bus.$off('startPreviewUrl').$on('startPreviewUrl', (data) => {
		console.log('startPreview --- ' + data)
		this.previewRes(data,true)
	})

      //zmf 初始化启动监听
      //this.startLoop();

	  //zmf 增加微信返回接口监听 暂停保留
	  // window.addEventListener('popstate', function pdfHistoryPopstate(evt) {
	  //   if(that.previewURL && that.previewURL.path){
	  // 	  alert("微信返回");
	  // 	  that.sendOpenDulTime(that.previewURL);
	  //   }
	  // });

	  // this.componentDidMount();
	  // const eventName = $deviceTypeIs('ios') ? 'pagehide' : 'unload';
	  // window.addEventListener(eventName, (e) => {
	  // 	alert("微信关闭2222");
	  // });
	  // window.onunload = function () {
	  // 	alert("微信关闭3333");
	  // }
	  // WeixinJSBridge.invoke('closeWindow',{},function(res){
	  // 	alert("微信关闭1111");
	  // });

	  //浏览器监听页面显示，隐藏
	  // let that = this;
	  // document.addEventListener("visibilitychange",()=>{
	  // 	if(document.visibilityState =='visible') {
	  // 		//测试
	  // 		alert("微信显示");
	  // 	}
	  // 	if(document.visibilityState=='hidden'){
	  // 		//测试
	  // 		alert("微信隐藏");
	  // 	}
	  // })
    }
}
</script>

<style>
#app {
  font-family: "icomoon", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow: hidden;
  /* overflow: auto; */

  /* min-height: 100vh; */
  /* width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0; */
}

#app.pc {
  width: 414px;
  /* height: 736px; */
  margin: auto;
  position: relative;
  min-height: 100vh;
  height: 100vh;
  background-color: #f8f8f8;
}

#app.pc .footer {
  width: 414px;
  left: 50%;
  margin-left: -207px;
}
#app.pc .course-detail-box .course-box {
  width: 414px;
  left: 50%;
  margin-left: -207px;
}

#app.pc .btn-fixed,
#app.pc .btn-bottom-grey {
  width: 414px;
  left: 50%;
  margin-left: -207px;
}

#app.pc .input-box-wrapper,
#app.pc .reply-box,
#app.pc .btn-box,
#app.pc .topic-box,
#app.pc .class-top-wrap,
#app.pc .btn-pc-fixed {
  width: 414px;
  left: 50%;
  margin-left: -207px;
}

.res-iframe {
  position: fixed;
  height: 100vh;
  width: 100%;
  overflow: auto;
  /* overflow-y: scroll;
  -webkit-overflow-scrolling:touch;  */
  opacity: 1;
  top: 0;
  left: 0;

  display: none;
  z-index: 9999;
  background-color: #fff;
}

.res-iframe iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue